// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__19KpW","notes":"Notes_notes__30MNf","note":"Notes_note__23FDM","markdown":"Notes_markdown__1b0NO"};